<template>
  <tbody class="search__result" v-if="filteredResults !== undefined && filteredResults.length > 0">
    <tr v-for="(result, index) in filteredResults" v-bind:key="result.labelCode" :class="{'even': index % 2 === 0, 'odd': index % 2 !== 0}">
      <td class="search__result__td--labelCode" title="Labelcode">{{ result.labelCode }}</td>
      <td class="search__result__td--label" title="Name des Labels">{{ result.label }}</td>
      <td class="search__result__td--shortName" title="Kurzname des Labels">{{ result.shortName }}</td>
      <td class="search__result__td--plm" title="Musik einer Production Library / Archivmusik"><span v-if="result.plm">✔</span></td>
      <td class="search__result__td--producer" title="Name des Herstellers">{{ result.companyName }}</td>
      <td class="search__result__td--rightrecalls" title="Liste der Rechterückrufe" @click="showModal" :data-labelcode="result.labelCode">{{ formatRestrictions(result.restrictions) }}</td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: 'SearchResultRows',
  components: {
  },
  props: {
    filteredResults: Array
  },
  methods: {
    formatRestrictions (restrictions) {
      if (!restrictions) {
        return ''
      }
      return restrictions.join(', ')
    },
    showModal (evnt) {
      const elementContent = evnt.target.innerText
      const labelCode = evnt.target.dataset.labelcode
      this.$log.debug('elementContent: ', elementContent, evnt, evnt.target.dataset.labelcode)
      if (elementContent !== '' && this.$parent.showModal) {
        this.$parent.showModal(elementContent, labelCode)
      }
    }
  }
}
</script>
